import { z } from "zod";

// 管理ダッシュボードの集計（Kysely で件数集計・[19] §4.3）
export const dashboardSchema = z.object({
  companies: z.object({
    pending: z.number().int(),
    approved: z.number().int(),
    rejected: z.number().int(),
  }),
  schools: z.object({
    total: z.number().int(),
  }),
  // 業種別の企業数（§2.4/§3.1 の運用指標）。other の割合が高い＝分類が実態に合っていない兆候。
  // 承認済み・未削除の企業のみを数える（公開の実態に近い母数）。sort_order 順。
  industries: z.array(
    z.object({
      code: z.string(),
      label: z.string(),
      count: z.number().int(),
    }),
  ),
  applications: z.object({
    applied: z.number().int(),
    approved: z.number().int(),
    rejected: z.number().int(),
    cancelled: z.number().int(),
    // 企業へ未通知（§5）: applied のうち通知未送信で15分以上経過した件数。0 でない＝要対応。
    unnotified: z.number().int(),
  }),
});
export type Dashboard = z.infer<typeof dashboardSchema>;
